import { BlocksIconNoWifi } from 'blocks-nextjs/blocks-web-components/components/icon/icons/no-wifi';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconNoWifi = createComponent({ react: React, tagName: 'cat-icon-no-wifi', elementClass: BlocksIconNoWifi });
